import { render } from "./CreateInscription.vue?vue&type=template&id=e3ead9be&scoped=true"
import script from "./CreateInscription.vue?vue&type=script&lang=js"
export * from "./CreateInscription.vue?vue&type=script&lang=js"

import "./CreateInscription.vue?vue&type=style&index=0&id=e3ead9be&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3ead9be"]])

export default __exports__